import { Dispatch, SetStateAction, SyntheticEvent } from 'react'
import {
  FormControlLabel,
  FormGroup,
  Grid,
  SelectChangeEvent,
  Switch,
  useTheme,
} from '@mui/material'
import { useTranslation } from 'react-i18next'

import { FormSelect } from '../form-select'

import { ICheckboxSelectOption, IFilter, IFilterSelectionOption } from './types/filter.types'
import useStyles from './styles'
import { ETranslationNs } from 'src/types'
import { HelperWrapper } from '../helper-wrapper'
import FilterDateRangePicker from '../date-range-picker'

export interface IDesktopFilterProps {
  filter: IFilter
  selectionOptions: IFilterSelectionOption[]
  handleSelectChange: (queryName: string) => (e: SelectChangeEvent<string[]>) => void
  checkboxValues: ICheckboxSelectOption[]
  handleCheckboxChange: (e: SyntheticEvent) => void
  setFilter: Dispatch<SetStateAction<IFilter>>
  noClear?: boolean
  showDateFilter: boolean
}

const SelectionFilters = ({
  selectionOptions,
  handleSelectChange,
  filter,
  checkboxValues,
  handleCheckboxChange,
  setFilter,
  noClear,
  showDateFilter,
}: IDesktopFilterProps) => {
  const [t] = useTranslation(ETranslationNs.Filter)
  const classes = useStyles()
  const theme = useTheme()

  return (
    <Grid container className={classes.selectionContainer}>
      <Grid item xs={12} className={classes.selectionOptionsWrapper}>
        {showDateFilter && (
          <FilterDateRangePicker
            filter={filter}
            setFilterDate={setFilter}
            clearFilter={() =>
              setFilter({ ...filter, date_range_from: undefined, date_range_to: undefined })
            }
          />
        )}
        {!!selectionOptions.length && (
          <>
            {selectionOptions.map((item) => (
              <FormSelect
                withSearch={item.withSearch}
                key={item.queryParamName}
                selectName={t(item.selectName, { ns: ETranslationNs.Filter })}
                items={item.items}
                handleChange={handleSelectChange(item.queryParamName)}
                filter={filter}
                setFilter={setFilter}
                value={filter[item.queryParamName] as string[]}
                multiple={Array.isArray(filter[item.queryParamName])}
                paramName={item.queryParamName}
                noClear={noClear}
              />
            ))}
          </>
        )}
        {!!checkboxValues.length && (
          <FormGroup row={true}>
            {checkboxValues.map((checkbox) => (
              <FormControlLabel
                style={{ color: theme.palette.text.primary }}
                key={checkbox.label}
                className={classes.formCheckboxText}
                control={
                  <Switch
                    className={classes.checkboxSt}
                    inputProps={{ className: classes.formCheckbox }}
                  />
                }
                checked={!!filter[checkbox.queryParamName]}
                name={checkbox.queryParamName}
                onChange={handleCheckboxChange}
                label={<HelperWrapper t={checkbox.label} ns={ETranslationNs.Filter} />}
              />
            ))}
          </FormGroup>
        )}
      </Grid>
    </Grid>
  )
}

export { SelectionFilters }
